import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { SplitButton } from 'primereact/splitbutton'
import {
  Bar,
  BarChart,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { azul } from '../../../../assets/js/colors'
import { CustomMultiSelect, CustomPanel, PageHeader, Periodo } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useRelatorioPosicaoDiaria, { LOAD_MESSAGE } from './RelatorioPosicaoDiariaHook'
// import { DateTime } from 'luxon'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import { openReportInNewTab } from '../../../../services/util/report.service'

function RelatorioPosicaoDiaria({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useRelatorioPosicaoDiaria()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        if (!state.selectedEstoques || state.selectedEstoques.length === 0)
          throw new Error('Selecione pelo menos um estoque')
        if (!state.selectedEmpresas || state.selectedEmpresas.length === 0)
          throw new Error('Selecione pelo menos uma empresa')
        if (!state.periodo.dataInicial) throw new Error('Selecione uma data inicial')
        if (!state.periodo.dataFinal) throw new Error('Selecione uma data final')
        localDispatch.getPosicoesEstoquesDiarioRelatorio(
          state.selectedEstoques.map(e => e.id),
          state.selectedEmpresas.map(e => e.id),
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // function onHandleGetPosicoesEstoquesDiarioRelatorio() {
  //   localDispatch.getPosicoesEstoquesDiarioRelatorio(
  //     state.selectedEstoque.id,
  //     state.selectedEmpresas.map(e => e.id),
  //     state.periodo.dataInicial,
  //     state.periodo.dataFinal,
  //   )
  // }

  const onGerarRelatorioGraficoClick = () => {
    const estoquesIds = state.selectedEstoques ? state.selectedEstoques.map(e => e.id) : []
    const companyIds = state.selectedEmpresas.map(e => e.id)
    if (!selectedTp || estoquesIds.length === 0 || companyIds.length === 0) return

    openReportInNewTab(
      EstoqueHttp.urlReportPosicoesEstoqueOcupadasDiariaGrafico(
        selectedTp,
        estoquesIds,
        companyIds,
        parseToMysqlFormat(state.periodo.dataInicial),
        parseToMysqlFormat(state.periodo.dataFinal),
      ),
    )
  }

  const onGerarRelatorioPorEmpresaClick = () => {
    const estoquesIds = state.selectedEstoques ? state.selectedEstoques.map(e => e.id) : []
    const companyIds = state.selectedEmpresas.map(e => e.id)
    if (!selectedTp || estoquesIds.length === 0 || companyIds.length === 0) return

    openReportInNewTab(
      EstoqueHttp.urlReportPosicoesEstoqueOcupadasDiaria(
        selectedTp,
        estoquesIds,
        companyIds,
        parseToMysqlFormat(state.periodo.dataInicial),
        parseToMysqlFormat(state.periodo.dataFinal),
      ),
    )
  }

  const onGerarRelatorioPorPosicaoClick = () => {
    const estoquesIds = state.selectedEstoques ? state.selectedEstoques.map(e => e.id) : []
    const companyIds = state.selectedEmpresas.map(e => e.id)
    if (!selectedTp || estoquesIds.length === 0 || companyIds.length === 0) return

    openReportInNewTab(
      EstoqueHttp.urlReportPosicoesEstoqueOcupadasDiariaPorPosicao(
        selectedTp,
        estoquesIds,
        companyIds,
        parseToMysqlFormat(state.periodo.dataInicial),
        parseToMysqlFormat(state.periodo.dataFinal),
      ),
    )
  }

  const splitButtonItems = [
    {
      label: 'Gerar Relatório da Diária',
      command: onGerarRelatorioPorEmpresaClick,
    },
    {
      label: 'Gerar Relatório - Por posição',
      command: onGerarRelatorioPorPosicaoClick,
    },
  ]

  return (
    <div>
      <PageHeader>8.18 - RELATÓRIO POSIÇÕES DE ESTOQUE OCUPADAS DIÁRIA</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <>
            <div className="p-grid" style={{ marginBottom: 20 }}>
              <div className="p-col-3">
                <CustomMultiSelect
                  marginTop={9}
                  disabled={!selectedTp}
                  placeholder="Selecione Estoques"
                  optionLabel={'name'}
                  options={state.estoques}
                  label={'Estoques'}
                  filter={true}
                  onChange={value => localDispatch.onChange('selectedEstoques', value)}
                  value={state.selectedEstoques}
                />
              </div>
              <div className="p-col-3">
                <CustomMultiSelect
                  marginTop={9}
                  disabled={!selectedTp || state.selectedEstoques.length === 0}
                  placeholder="Selecione Empresas"
                  optionLabel={'name'}
                  options={getEmpresas().map(e => ({ id: e.id, name: e.name }))}
                  label={'Empresas'}
                  filter={true}
                  onChange={value => localDispatch.onChange('selectedEmpresas', value)}
                  value={state.selectedEmpresas}
                />
              </div>
              <div className="p-col-6 p-md-4">
                <Periodo
                  btnEnabled={
                    state.selectedEstoques.length > 0 && state.selectedEmpresas.length > 0
                  }
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onChangePeriodoInicial={value =>
                    localDispatch.onChange('periodo', { ...state.periodo, dataInicial: value })
                  }
                  onChangePeriodoFinal={value =>
                    localDispatch.onChange('periodo', { ...state.periodo, dataFinal: value })
                  }
                  onPesquisar={(pInicial, pFinal) => {
                    localDispatch.onChange('periodo', { dataInicial: pInicial, dataFinal: pFinal })
                    localDispatch.getPosicoesEstoquesDiarioRelatorio(
                      state.selectedEstoques.map(e => e.id),
                      state.selectedEmpresas.map(e => e.id),
                      pInicial,
                      pFinal,
                    )
                  }}
                />
              </div>
              <div className="p-col-6 p-md-2" style={{ paddingTop: 35 }}>
                <SplitButton
                  menuStyle={{ width: 300 }}
                  className="bck-primary"
                  label="Gerar Relatório - Gráfico"
                  disabled={
                    !(state.selectedEstoques.length > 0 && state.selectedEmpresas.length > 0)
                  }
                  onClick={onGerarRelatorioGraficoClick}
                  model={splitButtonItems}
                ></SplitButton>
              </div>
              <div className="p-col-12">
                <h3 style={{ marginBottom: 10, marginTop: 20 }}>Quantidade de Posições Ocupadas</h3>
                <BarChartEstoque
                  data={state.posicoesEstoque}
                  periodo={state.periodo}
                  dataKey="qte_posicoes"
                  nameLabel="Posições Ocupadas"
                />
              </div>
              <div className="p-col-12">
                <h3 style={{ marginBottom: 10, marginTop: 20 }}>Valor dos Produtos Estocados</h3>
                <BarChartEstoque
                  data={state.posicoesEstoque}
                  periodo={state.periodo}
                  dataKey="valor_financeiro"
                  nameLabel="Valor (R$)"
                  formatValue={value => `${value.toFixed(2)}`}
                />
              </div>
              <div className="p-col-12">
                <h3 style={{ marginBottom: 10, marginTop: 20 }}>Quantidade Pallet Alocados</h3>
                <BarChartEstoque
                  data={state.posicoesEstoque}
                  periodo={state.periodo}
                  dataKey="qtde_pallet"
                  nameLabel="Pallets"
                />
              </div>
            </div>
          </>
        </CustomPanel>
      </div>
    </div>
  )
}

const BarChartEstoque = ({
  data,
  periodo,
  dataKey = 'qte_posicoes',
  nameLabel = 'Posições Ocupadas',
  formatValue,
}) => {
  // const dataInicial = DateTime.fromISO(new Date(periodo.dataInicial).toISOString())
  // const dataFinal = DateTime.fromISO(new Date(periodo.dataFinal).toISOString())
  // let lastDate = dataInicial

  // const allDates = Array.from(
  //   new Set(data.flatMap(estoque => Object.keys(estoque.detalhesPorData))),
  // ).filter(d => {
  //   const date = DateTime.fromFormat(d, 'yyyy-MM-dd')
  //   if (date < lastDate) lastDate = date
  //   return date >= dataInicial && date <= dataFinal
  // })

  // let lastValue = data.reduce((count, estoque) => {
  //   return estoque.detalhesPorData[lastDate.toFormat('yyyy-MM-dd')] > 0 ? count + 1 : count
  // }, 0)

  // const formattedData = allDates.map(date => {
  //   const formattedDate = formatDateToLocale(date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
  //   const occupiedPositions = data.reduce((count, estoque) => {
  //     return estoque.detalhesPorData[date] > 0 ? count + 1 : count
  //   }, 0)

  //   return { date: formattedDate, occupiedPositions }
  // })
  // let date = dataInicial
  // const foundDates = formattedData.map(d => d.date)

  // const dateSet = new Set(foundDates)

  // while (date <= dataFinal) {
  //   const formattedDate = date.toFormat('dd/MM/yyyy')

  //   if (!dateSet.has(formattedDate)) {
  //     formattedData.push({ date: formattedDate, occupiedPositions: lastValue })
  //   } else {
  //     const found = formattedData.find(d => d.date === formattedDate)
  //     if (found) lastValue = found.occupiedPositions
  //   }

  //   date = date.plus({ days: 1 })
  // }

  // formattedData.sort((a, b) => {
  //   const aDate = formatDateToLocale(a.date, 'dd/MM/yyyy')
  //   const bDate = formatDateToLocale(b.date, 'dd/MM/yyyy')
  //   return aDate > bDate ? 1 : -1
  // })

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const value = payload[0].value
      const displayValue = formatValue ? formatValue(value) : value
      return (
        <div
          style={{
            backgroundColor: 'white',
            border: '1px solid #ccc',
            padding: '10px',
            borderRadius: '5px',
          }}
        >
          <p style={{ margin: 0 }}>{`${nameLabel}: ${displayValue}`}</p>
        </div>
      )
    }
    return null
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      {(data.length === 0 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            fontSize: 20,
          }}
        >
          Não há dados para o período selecionado
        </div>
      )) || (
        <BarChart data={data} margin={{ top: 30 }}>
          <XAxis dataKey="dia" tickFormatter={str => str.substring(8, 10)} />
          <YAxis allowDecimals={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey={dataKey} fill={azul} name={nameLabel} isAnimationActive={false}>
            <LabelList
              dataKey={dataKey}
              position="top"
              fontSize={20}
              fill="#000"
              formatter={formatValue}
            />
          </Bar>
        </BarChart>
      )}
    </ResponsiveContainer>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(RelatorioPosicaoDiaria))
